<!--
 * @Description: 商户审核页面
 * @Author: gaohc
 * @Date: 2022-10-09 16:43:52
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="8" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 187px" v-model="filterParams.institutionId"
          clearable filterable placeholder="请输入/选择"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
            srcInstitutionList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
            'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name"
			      :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: left">
        <span class="search-title">申请状态：</span>
        <el-select size="small" style="width: 187px" placeholder="请输入/选择"
          clearable v-model="filterParams.status" filterable>
          <el-option v-for="item in statusList" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: left">
        <span class="search-title">微信申请编号：</span>
        <el-input size="small" style="width: 187px" placeholder="请输入"
					v-model="filterParams.requestNo" clearable>
        </el-input>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">
					搜 索
				</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 25px 40px; border: 1px solid #f0f0f0" :style="tableWidth" ref="table"
      :data="dataTable" header-cell-class-name="table-header-color"
			:default-sort="{ prop: 'date', order: 'descending' }" row-key="id">
      <el-table-column label="机构名称" min-width="15%" align="left">
        <template slot-scope="scope">
          {{ scope.row.institutionName ? scope.row.institutionName : "- -" }}
        </template>
      </el-table-column>
      <el-table-column prop="mainTypeTxt" label="经营主体" min-width="10%" align="center">
			</el-table-column>
      <el-table-column label="提交人" min-width="12%" align="center">
        <template slot-scope="scope">
          {{ scope.row.submiterText ? scope.row.submiterText : "- -" }}
        </template>
      </el-table-column>
      <el-table-column label="申请状态" min-width="18%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.reviewHistoryList && !scope.row.reviewHistoryList.length"
            :style="{color: scope.row.status == '2' || scope.row.status == '35' ? '#FF0909'
							: scope.row.status == '0' ? '#999999' : '#606266'}">
            {{ scope.row.statusText }}
          </span>
          <review-tooltip v-else :reviewStatus="scope.row.status" :statusText="scope.row.statusText"
            :data="scope.row.reviewHistoryList">
          </review-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" prop="submitTime" sortable min-width="18%" align="left">
        <template slot-scope="scope">
          {{ scope.row.submitTime ? scope.row.submitTime : "- -" }}
        </template>
      </el-table-column>
      <el-table-column prop="createrName" label="微信申请编号" min-width="15%" align="left">
        <template slot-scope="scope">
          {{ scope.row.requestNo ? scope.row.requestNo : "- -" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="12%" align="left">
        <template slot-scope="scope">
          <span v-for="(i, idx) in scope.row.operationTextList" :key="idx">
            <el-button @click="handleOperation(scope.row, i)" type="text" size="small">
							{{ i }}
						</el-button>
            <el-divider v-if="idx != scope.row.operationTextList.length - 1" direction="vertical">
            </el-divider>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"/>
    </el-row>
    <!-- 签约抽屉 -->
    <mch-signing-drawer :visible="showMchSigningDrawer" @close-dialog="showMchSigningDrawer = false"
      :mchId="mchId">
    </mch-signing-drawer>

    <!-- 账户验证抽屉 -->
    <mch-validation-drawer @close-dialog="showMchValidationDrawer = false"
      :mchId="mchId" :visible="showMchValidationDrawer">
    </mch-validation-drawer>

    <!-- 查看详情抽屉 -->
    <mch-review-details-drawer :visible="showMchReviewDetailsDrawer" :isGlobalAdmin="isGlobalAdmin"
      @handle-review-attendant="handleMchReview" @close-dialog="showMchReviewDetailsDrawer = false"
			:mchId="mchId">
    </mch-review-details-drawer>

    <!-- 编辑表单抽屉 -->
    <mch-edit-form-drawer :visible="showEditFormDrawer" @close-drawer="handleCloseEditMchFormDraw"
      :mchId="mchId">
    </mch-edit-form-drawer>

    <!-- 审核意见弹框 -->
    <review-comments-dialog :showReviewCommentsDialog="showReviewCommentsDialog"
      @handle-close-review-comments-dialog="handleCloseReviewCommentsDialog"
      :reviewStatus="reviewStatus" :reviewType="reviewType"
			@handle-review-comments-msg="handleReviewCommentsMsg"/>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import MchSigning from "./components/mchReviewList/MchSigning.vue";
import MchValidation from "./components/mchReviewList/MchValidation.vue";
import MchReviewDetails from "./components/mchReviewList/MchReviewDetails.vue";
import MchEditForm from "./components/mchReviewList/MchEditForm.vue";
import ReviewCommentsDialog from "./components/ReviewCommentsDialog.vue";
import ReviewTooltip from "./components/ReviewTooltip.vue";

export default {
  name: "MchReviewList",
  components: {
    "mch-signing-drawer": MchSigning,
    "mch-validation-drawer": MchValidation,
    "mch-review-details-drawer": MchReviewDetails,
    "mch-edit-form-drawer": MchEditForm,
    "review-comments-dialog": ReviewCommentsDialog,
    "review-tooltip": ReviewTooltip,
  },

  data() {
    return {
      filterParams: {
        institutionId: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      institutionList: [],
      srcInstitutionList: [],
      statusList: [],
      dataTable: [],
      reviewPrivilege: {},

      mchId: null,
			isGlobalAdmin: null,
      showMchSigningDrawer: false,

      // 账户验证抽屉变量
      showMchValidationDrawer: false,
      showMchReviewDetailsDrawer: false,
      showEditFormDrawer: false,

      // 审核弹框变量
      showReviewCommentsDialog: false,
      reviewStatus: "", //商户审核状态
      reviewType: "",
      reviewParams: {}, //审核参数对象
    };
  },

  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    }
  },

  methods: {
    handleQuery() {
      this.filterParams.page = 1;
      this.listReviewMchList();
    },

    //审核操作逻辑
    handleOperation(item, opeType) {
      if (opeType == "详情") {
        this.handleCheckDetails(item.id);
      } else if (opeType == "审核") {
        this.handleReview(item);
      } else if (opeType == "签约") {
        this.handleSignContract(item.id);
      } else if (opeType == "账户验证") {
        this.handleVerifyAccount(item.id);
      } else if (opeType == "编辑") {
        this.handleEditMchForm(item.id);
      } else if (opeType == "撤回") {
        this.handleWithdraw(item);
      }
    },

    //账户验证
    handleVerifyAccount(mchReviewId) {
      this.mchId = mchReviewId;
      this.showMchValidationDrawer = true;
    },

    //签约
    handleSignContract(mchReviewId) {
      this.mchId = mchReviewId;
      this.showMchSigningDrawer = true;
    },

    handleReview(item) {
      this.reviewType = "mchReview";
      this.mchId = item.id;
      this.reviewParams.id = item.id;
      this.reviewParams.version = item.version;
      this.reviewStatus = "";
      this.showReviewCommentsDialog = true;
    },

    handleCheckDetails(mchReviewId) {
      this.mchId = mchReviewId;
      this.showMchReviewDetailsDrawer = true;
    },

    //商户编辑
    handleEditMchForm(mchReviewId) {
      this.mchId = mchReviewId;
      this.showEditFormDrawer = true;
    },

    handleCloseEditMchFormDraw(refresh) {
      this.showEditFormDrawer = false;
      if (refresh) this.listReviewMchList();
    },

    //撤回
    handleWithdraw(item) {
      this.reviewParams.id = item.id;
      this.reviewParams.status = "canceled";
      this.reviewParams.version = item.version;
      this.$confirm(item.institutionName + "申请的商户资料将被撤回，是否继续?", "提示",{
          confirmButtonText: "确 定",
          cancelButtonText: "取 消",
          type: "warning",
        }).then(() => {
          this.handleRevokeReview(item.id);
        });
    },

    //撤回审核
    handleRevokeReview(mchReviewId) {
      this.queryReviewStatusChange(Constant.URL_REVOKE_MERCHANT_REVIEW, {reviewId: mchReviewId});
    },

    handleMchReview(reviewStatus, version) {
      this.reviewType = "mchReview";
      this.reviewParams.id = this.mchId;
      this.reviewParams.version = version;
      this.reviewStatus = reviewStatus;
      this.showReviewCommentsDialog = true;
    },

    //审核意见框确定
    handleReviewCommentsMsg(comment, status) {
      this.reviewParams.comment = comment;
      this.reviewParams.status = status;
      this.queryReviewStatusChange(Constant.URL_UPDATE_MERCHANT_REVIEW_RESULT, this.reviewParams);
      this.showReviewCommentsDialog = false;
      this.showMchReviewDetailsDrawer = false;
    },

    //关闭审核意见弹框
    handleCloseReviewCommentsDialog(boolean) {
      this.showReviewCommentsDialog = boolean;
    },

    //撤回或者商户审核或驳回
    queryReviewStatusChange(url, param) {
      let header = this.encryptionUtil.signatureBody(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: url,
        param: param,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        
        this.listReviewMchList();
      });
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listReviewMchList();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listReviewMchList();
    },

    getReviewerIsSuperAdmin() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_REVIEWER_IS_SUPER_ADMIN).then((result) => {
          if (result == null) {
            return;
          }

          this.isGlobalAdmin = result.data;
          resolve();
        })
      });
    },

    getMchReviewsFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_MERCHANT_REVIEW_FILTER_DO).then((result) => {
            if (result == null) {
              return;
            }

            this.institutionList = result.data.institutionList;
            this.srcInstitutionList = result.data.institutionList;
            this.statusList = this.commonUtil.map2List(result.data.statusMap,
							true, "value", "label");
            resolve();
          })
      });
    },

    listReviewMchList() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET', 
          url: Constant.URL_PAGE_MERCHANT_REVIEWS,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED
        };
        this.vueRequest(requestData).then(result => {
          if (result == null) {
            return;
          }
          this.dataTable = result.data;
          this.totalNumber = result.totalNumber;
          resolve();
        })
      });
    },

    async initView() {
      this.filterParams.institutionId = this.$route.params.institutionId;
      await this.getMchReviewsFilterDo();
      await this.getReviewerIsSuperAdmin();
      await this.listReviewMchList();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: "审核管理", text2: "商户审核"});
    this.initView();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/MchReviewList.vue